import React, { useState } from "react";
import Pendaftaran from "../../Components/form/pendaftaran";
import NavbarThree from "../../Components/Navbar/navbarThree";
import Footer from "../../Components/Footer";

const PagesPendaftaran = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <div>
      <NavbarThree isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <div className="pt-24">
        <Pendaftaran />
      </div>

      <Footer />
    </div>
  );
};

export default PagesPendaftaran;
